import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import { URL_PATHS } from "constants/index"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { getCodesList } from "store/actions"
import CodesList from "./codesList"

const Codes = ({ codes, getCodesList }) => {
  useEffect(() => {
    getCodesList({
      bch: 0,
      o: "created_at",
      od: "desc",
      page: 1,
    })
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Codes List" />
        <Container fluid>
          <BreadcrumbTitle
            title="Codes List"
            breadcrumbItems={[{ title: "Dashboard" }, { title: "Codes List" }]}
          />
          <Row className="d-flex justify-content-end mb-3">
            <Col xs="auto">
              <Link to={URL_PATHS.GENERATE_CODES}>
                <SaveButton type="button" content="Generate" />
              </Link>
            </Col>
          </Row>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <CodesList />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  codes: state.codes.codes,
})

const mapDispatchToProps = dispatch => ({
  getCodesList: values => dispatch(getCodesList(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Codes)
